import React from 'react';
import { ConfirmPin as ConfirmPinScreen } from '@features/confirm-pin';

export const ConfirmPin = (props: any) => <ConfirmPinScreen {...props} />;
